import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import getConfig from '../../../../../../../../util/config';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateWGNoJoinCode = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const {
    all_photos_mode: allPhotosMode,
    is_web_gallery: isWebGallery,
    joins_enabled: joinsEnabled,
  } = albumFolder;

  const isPublicAllPhotos = allPhotosMode === ALL_PHOTOS_MODE.PUBLIC;

  let url;
  if ((isWebGallery || isPublicAllPhotos) && !joinsEnabled) {
    url = albumFolder?.web_app_urls?.all_photos_access_url;
  } else if (joinsEnabled && !(isWebGallery || isPublicAllPhotos)) {
    url = albumFolder?.onboarding_short_url;
  } else {
    url = `${getConfig().app.baseUrl}/galleries/o/album-folder/${
      albumFolder.id
    }`;
  }

  return (
    <Fragment>
      <p className="marketing-material-flyer-header-copy">
        Don&apos;t Miss a Moment from <br />
        {albumFolder?.name}!
      </p>

      <div
        className="marketing-material-flyer-qrcode-secondary wg-flyer-qrcode wg-no-jc-flyer-qrcode"
        style={{
          top: '56%',
          right: `calc(50% - ${Math.round((width * 0.35 ?? 500) / 2)}px)`,
        }}
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.35 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_GENERAL_1_NO_JC.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateWGNoJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateWGNoJoinCode;
